import React from 'react';
import Navbar from './components/ui/Navbar';
import Footer from './components/ui/Footer';

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <style>{`
        :root {
          --color-primary: #1e293b;
          --color-accent: #f59e0b;
        }
        
        html {
          scroll-behavior: smooth;
        }
        
        body {
          font-family: 'Inter', system-ui, -apple-system, sans-serif;
        }
      `}</style>
      <Navbar />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  );
}